import React, { useEffect } from "react";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import RelatedWorks from "./RelatedWorks";
import CustomVideoPlayer from "./CustomVideoPlayer";
import refmaxVideo from "../../assets/Refmax/REFMAXLOGO-16-9.mp4";
import "./Mgrdetail.css";

export default function RefmaxDetails() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="work-detail-page">
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 1000 }}>
        <Navbar />
      </div>

      <section className="project-info-section">
        <h1 className="project-title-heading">
          Refmax
        </h1>

        <p className="project-description">
          We collaborated with Refmax to build a powerful and integrated brand presence across digital and physical touchpoints. From designing a high-performance corporate website and structured product brochures to crafting impactful social media campaigns, we positioned Refmax as an innovative leader in industrial refrigeration and engineering solutions.
        </p>

        <div className="project-tags">
          <span className="info-tag">Website Design</span>
          <span className="info-tag">Brochure Design</span>
          <span className="info-tag">Social Media Campaigns</span>
          <span className="info-tag">Brand Identity</span>
          <span className="info-tag">Motion Graphics</span>
        </div>
      </section>

      {/* First section: Video with reduced height */}
      <style>{`
        .refmax-video-container .custom-video-player-container {
          height: 65vh !important;
          min-height: 450px !important;
          max-height: 680px !important;
        }
        .refmax-video-container video {
          height: 100% !important;
          min-height: unset !important;
          max-height: 100% !important;
        }
        @media (max-width: 768px) {
          .refmax-video-container .custom-video-player-container {
            height: auto !important;
            min-height: auto !important;
            max-height: none !important;
            aspect-ratio: 16 / 9;
          }
        }
      `}</style>

      <div className="project-full-image-section refmax-video-container">
        <CustomVideoPlayer
          src={refmaxVideo}
          autoPlay
          loop
          muted
          playsInline
        />
      </div>

      <div className="project-full-image-section">
        <img 
          src="https://ascentbw.com/Images/Refmax/Img1.webp" 
          alt="Refmax Website & Brand Showcase" 
        />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We designed and developed a modern, user-centric corporate website for Refmax, engineered with seamless navigation, responsive architecture, and clear service categorization to effectively showcase their industrial refrigeration systems and drive client conversions."
        </div>
      </section>

      <div className="project-full-image-section">
        <img 
          src="https://ascentbw.com/Images/Refmax/Img2.webp" 
          alt="Refmax Brochure & Print Systems" 
        />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We crafted a comprehensive corporate brochure and product catalog for Refmax, combining structured technical layouts, clean typography, and bold visual storytelling to communicate complex engineering solutions with clarity and authority."
        </div>
      </section>

      <div className="project-full-image-section">
        <img 
          src="https://ascentbw.com/Images/Refmax/Img3.webp" 
          alt="Refmax Social Media & Brand Campaigns" 
        />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
          "We created dynamic social media creatives and digital brand campaigns for Refmax to amplify brand awareness, engage B2B stakeholders, and highlight key engineering achievements with a consistent and premium visual identity across all platforms."
        </div>
      </section>

      <RelatedWorks excludePath="/works/refmax" />
      <Footer />
    </div>
  );
}
